import { DEFAULT_EMPTY_VALUE } from '../../constants';
import { getItemOrDefaultToValue } from '../../details';

export const transformMessagingDetails = data => {
  return {
    generalInfo: {
      title: {
        type: 'text',
        field: 'title',
        value: getItemOrDefaultToValue(data, 'title', DEFAULT_EMPTY_VALUE),
      },
      to: {
        type: 'text',
        field: 'recipient',
        value: getItemOrDefaultToValue(
          data,
          'recipientFullName',
          DEFAULT_EMPTY_VALUE,
        ),
      },
      from: {
        type: 'text',
        field: 'sender',
        value: getItemOrDefaultToValue(
          data,
          'senderFullName',
          DEFAULT_EMPTY_VALUE,
        ),
      },
      dateSent: {
        type: 'text',
        field: 'dateSent',
        value: getItemOrDefaultToValue(data, 'sentAt', DEFAULT_EMPTY_VALUE),
      },
    },
    detailedInfo: {
      message: {
        type: 'text',
        value: getItemOrDefaultToValue(data, 'body', DEFAULT_EMPTY_VALUE),
      },
    },
  };
};
